import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class presetFilter_template extends vnTemplate{

    protected filterContainerClass: string;

    protected getTemplateHtml(): string{

        return `
            <div class="filter-preset  w-left">
                    <div class="dropdown filter-preset" data-bind="css:{'is-visible': isVisible()}">
                        <button class="dropdown-toggle filter" data-bind="click: onToggleOpen">filter views</button>

                        <div class="dropdown-list">
                            <button type="button" class="btn-close-default icon i-close" data-bind="click: onToggleOpen"><span></span></button>
                            <div class="filter-field-name">
                                <input class="input-text" placeholder="Add Filter View" data-bind="value: searchPresetName, valueUpdate: 'afterkeydown', event: {keyup: onPresetNameChange}"/>
                                <button class="clear icon i-close is-showing" type="button" data-bind="visible: searchPresetName() != '', event:{ click: onClearSearchPresetName }"><span class="hidden-text">clear</span></button>
                                <button class="btn highlight icon i-check" type="button" data-bind="visible: savePresetButtonEnabled(), event: { click: onSaveSearchPreset}" ><span>Save Preset</span></button>
                            </div>
                            <div data-bind="foreach: searchPresets">
                            <!-- ko if: $parent.searchPresetName() == '' || name.toLowerCase().indexOf($parent.searchPresetName().toLowerCase()) != -1 -->
                                <div class="btn secondary">
                                    <!-- ko if: isOwner -->
                                    <input type="checkbox" data-bind="checked: $parent.searchPresetFavorite().id == id,  value: id,  attr: { id: 'searchPreset_' + id, name: 'searchPreset'}">
                                    <label class="form-label icon"  data-bind="attr: {for: 'searchPreset_' + id }, event:{ click: $parent.onToggleSearchPresetAsFavorite}" ></label>
                                    <!-- /ko -->

                                    <span data-bind="event:{ click: $parent.onApplySearchPreset}, attr: {for: 'searchPreset_' + id }, text: name"></span>

                                    <button class="copy icon i-copy" title="Copy Link to clipboard" data-bind="event:{ click: $parent.onClickBookmarkPreset}"><span class="hide-text">Copy to clipboard</span></button>
                                    <!-- ko if: isOwner -->
                                    <button class="delete icon i-delete" data-bind="event:{ click: $parent.onDeleteSearchPreset}"><span>delete</span></button>
                                    <!-- /ko -->
                                </div>
                            <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>
            `;
    }

    protected getTemplateName(): string{
        return "presetFilter-template";
    }

    protected getMainElementClasses(): Array<string>{
        return [this.filterContainerClass];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        window.addEventListener('click', event => {
            const filter = document.getElementById(this.idElement);

            if(!filter?.contains(event.target as Element)){
                this.getTemplateViewModel().isVisible(false);
            }
        })

        return {
            searchPresetSelected: ko.observable({id: null, name: null}),
            searchPresetFavorite: ko.observable({id: null, name: null}),
            searchPresetName: ko.observable(''),
            searchPresetType: ko.observable(''),
            searchPresets: ko.observableArray([]),
            showSaveSearchPreset: ko.observable(false),
            disableSaveSearchPreset: ko.observable(false),
            savePresetButtonEnabled: ko.observable(false),
            isVisible: ko.observable(false),
            onToggleOpen: (data) => {
                huit_neuf_this.onToggleOpen();
            },
            onSaveSearchPreset: (data, event) => {
                huit_neuf_this.onSaveSearchPreset();
            },
            onClearSearchPresetName: (data, event) => {
                huit_neuf_this.onClearSearchPresetName();
            },
            onToggleSearchPresetAsFavorite: (data, event) => {
                huit_neuf_this.onToggleSearchPresetAsFavorite(data);
            },
            onDeleteSearchPreset: (data, event) => {
                huit_neuf_this.onDeleteSearchPreset(data);
            },
            onApplySearchPreset: (data, event) => {
                huit_neuf_this.onApplySearchPreset(data);
            },
            onShowSaveSearchPreset: (data, event) => {
                huit_neuf_this.onShowSaveSearchPreset();
            },
            onClickBookmarkPreset: (data, event) => {
                huit_neuf_this.onClickBookmarkPreset(data, event);
            },
            onPresetNameChange: (data, event) => {
                huit_neuf_this.onPresetNameChange(data, event);
            },
        };
    }

    public getViewModelForPresetRequest(){

        return {

            name: this.getTemplateViewModel().searchPresetName(),
            type: this.getTemplateViewModel().searchPresetType(),
            queryString: this.getQueryString(),
        }
    }

    public onToggleOpen(){

        this.getTemplateViewModel().isVisible(!this.getTemplateViewModel().isVisible());
    }

    public setType(type){

        this.getTemplateViewModel().searchPresetType(type);
    }


    public getFilterTextFromId(filtersOptions: Array<{id, name}>, id){

        let option = filtersOptions.filter((o) => (o.id == id)).shift();

        return option.name;
    }

    public onSaveSearchPreset(): void{

        let isSaveDisabled = this.getTemplateViewModel().disableSaveSearchPreset();

        if(!isSaveDisabled){

            this.disableSaveSearchPreset();
            this.caller.saveSearchPreset();
        }
    }

    public onClearSearchPresetName(): void{

        this.cleanSearchPresetName();
    }

    public disableSaveSearchPreset(): void{
        this.getTemplateViewModel().disableSaveSearchPreset(true);
    }

    public enableSaveSearchPreset(): void{
        this.getTemplateViewModel().disableSaveSearchPreset(false);
    }

    public cleanSearchPresetName(): void{
        this.getTemplateViewModel().searchPresetName('');
        this.getTemplateViewModel().savePresetButtonEnabled(false);
    }

    public onToggleSearchPresetAsFavorite(data): void{

        if(this.getTemplateViewModel().searchPresetFavorite() && this.getTemplateViewModel().searchPresetFavorite().id == data.id){

            this.getTemplateViewModel().searchPresetFavorite({id: null, name: null});
        }else{

            this.getTemplateViewModel().searchPresetFavorite(data);
        }

        this.caller.saveFavoriteSearchPreset({presetId: data.id, searchPresetType: this.getTemplateViewModel().searchPresetType()});
    }

    public onDeleteSearchPreset(preset): void{

        let presets = this.getTemplateViewModel().searchPresets();
        let remainingPresets = presets.filter((p) =>  (p.id != preset.id));

        this.getTemplateViewModel().searchPresets(remainingPresets);

        this.caller.deleteSearchPreset(preset.id);
    }

    public onApplySearchPreset(preset): void{

        this.caller.redirectToPreset(preset.queryString);
        this.caller.getListFormData();
    }

    public onShowSaveSearchPreset(): void{

        this.showSaveSearchPresetButton();
    }

    public onClickBookmarkPreset(data, event): void{

        this.caller.onClickBookmarkPreset(data.url)
    }

    public onPresetNameChange(data, event): void{

        if(this.getTemplateViewModel().searchPresetName().length > 0){

            this.getTemplateViewModel().savePresetButtonEnabled(false);
        }

        let match = false;
        for(let preset of this.getTemplateViewModel().searchPresets()){

            if(this.getTemplateViewModel().searchPresetName() == preset.name){

                match = true;
                break;
            }
        }

        this.getTemplateViewModel().savePresetButtonEnabled(!match);
    }

    public showSaveSearchPresetButton(): void{

        this.getTemplateViewModel().showSaveSearchPreset(true);
    }
    public hideSaveSearchPresetButton(): void{

        this.getTemplateViewModel().showSaveSearchPreset(false);
    }

    public getQueryString(){

        let href = window.location.href;
        let url = new URL(href);

        return url.search;
    }

    public setMultiSelectorPresetFilters(multiFilter, ids: Array<number>, containSearchString?: string): void{

        if(typeof ids === 'undefined'){

            return;
        }

        let items = [];
        ids.forEach((id) => {
            items.push({ id: id });
        });

        multiFilter.setSelectedItems(items);
        multiFilter.setTags(ids, multiFilter.getItems());

        if(multiFilter.getTemplateViewModel().displaySelectionOrder()){

            multiFilter.setSelectedItemsOrderBySelection(items);
        }

        if(containSearchString && containSearchString != ''){

            multiFilter.setContainSearchFilterKeyword(containSearchString);
        }
    }

    public setOrderSelectionMultiSelectorPresetFilters(multiFilter, ids: Array<number>): void{

        if(typeof ids === 'undefined'){

            return;
        }

        let items = [];
        ids.forEach((id) => {
            items.push({ id: id });
        });

        multiFilter.setSelectedItems(items);
        multiFilter.setTags(ids, multiFilter.getItems());

        multiFilter.setSelectAllEnabled(false);
        multiFilter.setDisplaySelectionOrder(true);

        if(multiFilter.getTemplateViewModel().displaySelectionOrder()){

            multiFilter.setSelectedItemsOrderBySelection(items);
        }
    }

    public setAutocompletePresetFilter(autocompleteFilter, id?: number, name?: string){

        if(id != null && name != null && name != 'undefined'){

            autocompleteFilter.getTemplateViewModel().idSelectedItem(id);
            autocompleteFilter.getTemplateViewModel().nameSelectedItem(name);
        }else{

            autocompleteFilter.getTemplateViewModel().idSelectedItem(null);
            autocompleteFilter.getTemplateViewModel().nameSelectedItem(null);
        }
    }

    public setMultipleAutocompletePresetFilter(autocompleteFilter, ids?: number[], names?: string[], containSearchString?: string){

        if(ids != null && names != null && ids.length == names.length){

            let items = [];
            for(let i = 0; i < ids.length; i++){

                items.push({id: ids[i], name: names[i]})
            }

            autocompleteFilter.getTemplateViewModel().selectedItems(items);
            autocompleteFilter.getTemplateViewModel().selectedItemIds(ids);
            autocompleteFilter.getTemplateViewModel().selectedItemNames(names);
            autocompleteFilter.getTemplateViewModel().setTags(ids, items);
        }else{

            autocompleteFilter.getTemplateViewModel().selectedItems([]);
            autocompleteFilter.getTemplateViewModel().selectedItemIds([]);
            autocompleteFilter.getTemplateViewModel().selectedItemNames([]);
            autocompleteFilter.getTemplateViewModel().setTags([], []);
        }

        if(containSearchString && containSearchString != ''){

            autocompleteFilter.setContainSearchFilterKeyword(containSearchString);
        }
    }

    public setSearchPresets(presets: Array<{id: number, idUser:number, name: string, queryString, isFavorite: boolean}>): void{

        for(let preset of presets){

            preset = this.precalculatePresetFields(preset);
        }

        this.getTemplateViewModel().searchPresets(presets);

        let isFavorite = presets.filter((p) => (p.isFavorite == true));
        let preset = isFavorite.shift();

        this.setSearchPresetFavorite(preset);
    }

    public precalculatePresetFields(preset: {id: number, idUser:number, name: string, queryString, isFavorite: boolean}){

        if(typeof preset !== 'undefined'){

            preset['url'] = location.protocol + '//' + location.host + location.pathname + preset.queryString;

            let isOwner = false;
            let vnApp = this.caller.getVnAppZone().app;
            if(vnApp.loggedUser.isLoggedIn){

                isOwner = vnApp.loggedUser.user.id == preset.idUser
            }

            preset['isOwner'] = isOwner;
        }

        return preset;
    }

    public setSearchPresetFavorite(preset: {id: number, idUser:number, name: string, queryString, isFavorite: boolean}){

        preset = this.precalculatePresetFields(preset);

        if(preset != undefined){

            this.getTemplateViewModel().searchPresetFavorite(preset);
        }
    }

    public addCreatedPresetToList(preset): void{

        preset = this.precalculatePresetFields(preset);
        this.cleanSearchPresetName();
        this.hideSaveSearchPresetButton();
        let presets = this.getTemplateViewModel().searchPresets();

        // append and sort.
        presets.push(preset);
        presets.sort((a,b) => (a.name.localeCompare(b.name)));

        this.getTemplateViewModel().searchPresets(presets);
        this.enableSaveSearchPreset();
    }

    public setDates(datesFilter, type?: string, startDate?: string, endDate?: string, startDateRange?: string, endDateRange?: string, selectedMonth?: string, selectedWeek?: string){

        // date filters.
        if (typeof type === 'undefined') {

            type = 'dates';
        }

        datesFilter.getTemplateViewModel().selectedFilter(type)

        if (type == 'dates') {

            if (typeof selectedMonth !== 'undefined') {

                datesFilter.setSelectedMonth(selectedMonth)
            }

            if (typeof selectedWeek !== 'undefined') {

                datesFilter.setSelectedWeek(selectedWeek)
            }

            if (typeof startDate !== 'undefined' || typeof endDate !== 'undefined') {

                let startDateObj;
                if (startDate) {

                    startDateObj = new Date(startDate.replace(/-/g, '\/'));
                }
                let endDateObj;
                if (endDate) {

                    endDateObj = new Date(endDate.replace(/-/g, '\/'));
                }

                datesFilter.setDateRange(startDateObj, endDateObj);
            }
        }

        if (type == 'range') {

            if (typeof startDateRange !== 'undefined' || typeof endDateRange !== 'undefined') {

                datesFilter.setRange(startDateRange, endDateRange);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template.ts